<template>
  <div :class="['coupon-slide', 'coupon' + couponStatus]" @click="handleBtn">
    <div class="info">
      <div class="name">
        <tag
          has-background
          :secondary-color="'#ffe6b9'"
          :corner-radius="4"
          :primary-color="'#96371c'"
          :tag-style="nameStyle"
          :font-size="10"
        >
          {{ couponShowName }}
        </tag>
      </div>
      <p class="title">
        <span class="symbol">¥</span>
        <span class="value">{{ couponValue }}</span>
      </p>
      <p class="threshold">
        {{ thresholdMsg }}
      </p>
    </div>

    <div class="action">
      <tag
        :corner-radius="10"
        :tag-style="actionStyle"
        :primary-color="primaryColor"
      >
        {{ couponText }}
      </tag>
    </div>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
const couponStatusText = {
  1: '立即领取',
  2: '去使用',
  3: '已抢光',
  4: '去使用',
  5: '已使用'
}

export default {
  name: 'CouponSlide',
  components: {
    Tag
  },
  props: {
    coupon: {
      type: Object,
      default: () => ({})
    },
    couponStyle: {
      type: Object,
      default: () => ({})
    },
    stockStatus: {
      type: Number,
      default: 0
    },
    couponValue: {
      type: String,
      default: ''
    },
    couponName: {
      type: String,
      default: ''
    },
    thresholdMsg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameStyle: {
        'min-width': '120px',
        'text-align': 'center',
        height: '28px',
        'border-top-left-radius': 0,
        'border-top-right-radius': 0,
        padding: '2px 0'
      }
    }
  },
  computed: {
    couponShowName() {
      return this.couponName.slice(0, 5)
    },
    couponStatus() {
      return this.coupon?.actionStatus
    },
    couponText() {
      return couponStatusText[this.couponStatus]
    },
    // 可领取
    canReceive() {
      return this.couponStatus === 1
    },
    // 已领不在使用时间内
    notInDate() {
      return this.couponStatus === 2
    },
    // 已抢光
    outSale() {
      return this.couponStatus === 3
    },
    // 已领可使用
    canUse() {
      return this.couponStatus === 4
    },
    // 已使用
    hasUsed() {
      return this.couponStatus === 5
    },
    actionStyle() {
      let actionStyle = {
        'background-image': 'linear-gradient(to right, #ff6200, #eb3600)',
        width: '120px',
        'text-align': 'center',
        height: '36px'
      }
      if (this.notInDate || this.canUse) {
        actionStyle = {
          border: '1px solid #f03100',
          width: '120px',
          'text-align': 'center',
          height: '36px'
        }
      } else if (this.outSale) {
        actionStyle = {
          'background-color': '#d8d8d8',
          width: '120px',
          'text-align': 'center',
          height: '36px'
        }
      } else if (this.hasUsed) {
        actionStyle = {
          border: '1px solid #bdbdbd',
          width: '120px',
          'text-align': 'center',
          height: '36px'
        }
      }
      return actionStyle
    },
    primaryColor() {
      let primaryColor = '#fff'
      if (this.notInDate || this.canUse) {
        primaryColor = '#f03100'
      } else if (this.outSale) {
        primaryColor = '#777777'
      } else if (this.hasUsed) {
        primaryColor = '#999'
      }
      return primaryColor
    }
  },
  methods: {
    handleBtn() {
      if (this.canReceive) {
        this.receive()
      }
      if (this.canUse || this.notInDate) {
        this.goUse()
      }
    },
    /**
     * 领劵
     */
    async receive() {
      this.$emit('receive-coupon')
    },
    /**
     * 去使用
     */
    goUse() {
      const { tickerInfo } = this.coupon
      if (tickerInfo?.click) {
        this.$track(
          tickerInfo.click.spm,
          Object.assign({}, tickerInfo.click.spmJson, tickerInfo.data)
        )
      }
      if (this.coupon?.jumpUrl) {
        this.$autoRedirect(this.coupon.jumpUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-slide {
  position: relative;

  width: 80px;
  height: 94px;
  margin-right: 8px;
  overflow: hidden;

  background-image: url('~@/images/cms/coupons/coupon_slide_get.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  flex: none;

  @include flex(column, normal, center);
  &:last-child {
    margin-right: 0;
  }
  .info {
    width: 64px;
    padding-top: 4px;
    .name {
      height: 14px;
      margin-left: 2px;
      overflow: hidden;

      box-sizing: content-box;

      @include flex(row, flex-start, flex-start, wrap);
    }
    .title {
      margin-top: 3px;

      font-weight: $fw-bold;

      text-align: center;

      @include text-overflow-ellipsis-single;

      .symbol {
        position: relative;
        bottom: 2px;

        font-size: 12px;
        color: #f03100;
      }

      .value {
        font-size: 24px;
        color: #f03100;
      }
    }

    .type {
      margin-top: 2px;

      font-size: 11px;
      color: white;

      @include text-overflow-ellipsis-single;
    }

    .threshold {
      margin-top: 2px;

      font-size: 10px;
      line-height: 12px;
      text-align: center;
      color: #7d310b;
      @include text-overflow-ellipsis-single;
    }
  }

  .action {
    position: absolute;
    bottom: 8px;

    height: 18px;
    margin-left: 4px;
    overflow: hidden;

    box-sizing: content-box;

    @include flex(row, flex-start, flex-start, wrap);
  }
}
</style>
